<div class="workerListDisplay t-{{activeTheme.theme}}-dialog">
  <mat-toolbar class="workerListHeader" color="primary">
    <p>{{ 'LOGGEDIN_WORKERS' | translate }}</p>
    <span class="app-toolbar-filler"></span>
    <button mat-button class="buttonIcon" (click)="dialogRef.close()">
      <i class="material-icons">close</i>
    </button>
  </mat-toolbar>

  <mat-list class="workerList">
    @for (worker of visibleWorkers$ | async; track worker) {
      <mat-list-item>
        <img mat-list-avatar [src]="worker.userImage.safeSrc">
        <h3 mat-line> {{worker.apiData.caption}} </h3>
        @if (appService.getInterfaceAttendanceDetailed() && worker._apiData.currentcicotyp) {
          <img class="attIcon"
            [alt]="appService.getCiCoIconTitle(worker)"
            [title]="appService.getCiCoIconTitle(worker)"
            [style.background-color]="appService.getCiCoIconColor(worker)"
            [src]="appService.getCiCoIcon(worker)">
        }
      </mat-list-item>
    }
  </mat-list>

</div>
